export default __webpack_public_path__ + "static/media/4.04822b4d.png";